module.exports = __webpack_public_path__ + "img/klaus-a3-3.d4bb08fd.jpg";